export default {
    AttachmentCreation: {
        datapoint: {
            name: 'AttachmentCreation',
            customData: function (isInline, shouldShare, attachmentFileType, size) { return [isInline, shouldShare, attachmentFileType, size]; },
        },
    },
    AttachmentDeletion: {
        datapoint: {
            name: 'AttachmentDeletion',
            customData: function (isInline, isCloudy, size) { return [isCloudy, size]; },
        },
    },
    AttachmentCreationFailure: {
        datapoint: {
            name: 'AttachmentCreationFailure',
            customData: function (error) { return [null]; },
        },
    },
    AttachmentDeletionFailure: {
        datapoint: {
            name: 'AttachmentDeletionFailure',
            customData: function (error) { return [error]; },
        },
    },
    AttachmentCreationClassicFromAttachmentDataProvider: {
        datapoint: {
            name: 'AttachmentCreationClassicFromAttachmentDataProvider',
            customData: function (providerType) { return [providerType]; },
        },
    },
    AttachmentCreationClassicFromLocalFile: {
        datapoint: {
            name: 'AttachmentCreationClassicFromLocalFile',
            customData: function (parentItemId, attachment, cancellationId, backingObject) {
                return backingObject ? [backingObject.size] : [0]; // Log 0 if no backing object
            },
        },
    },
    AttachmentCreationFromRecentAttachment: {
        datapoint: {
            name: 'AttachmentCreationFromRecentAttachment',
            customData: function (parentItemId, attachment, cancellationId, backingObject) {
                return backingObject ? [backingObject.size] : [0]; // Log 0 if no backing object
            },
        },
    },
    AttachmentCreationClassicFromLocalFileSliced: {
        datapoint: {
            name: 'AttachmentCreationClassicFromLocalFileSliced',
            customData: function (size) { return [size]; },
        },
    },
    AttachmentCreationCloudyFromAttachmentDataProvider: {
        datapoint: {
            name: 'AttachmentCreationCloudyFromAttachmentDataProvider',
            customData: function (parentItemId, cancellationId, backingObject, attachmentState) { return [backingObject.providerType]; },
        },
    },
    AttachmentCreationCloudyFromLocalFile: {
        datapoint: {
            name: 'AttachmentCreationCloudyFromLocalFile',
        },
    },
    AttachmentSaveAllToCloud: {
        datapoint: {
            name: 'AttachmentSaveAllToCloud',
            customData: function (attachmentsTotalSize, succeeded, lastResult) { return [attachmentsTotalSize, succeeded, lastResult]; },
        },
    },
    AttachmentDeletionAction: { datapoint: { name: 'AttachmentDeletionAction' } },
    AttachmentWellInitialization: { datapoint: { name: 'AttachmentWellInitialization' } },
    AttachmentsCanNotShareInternally: { datapoint: { name: 'AttachmentsCanNotShareInternally' } },
    AttachmentCreationFromUri: {
        datapoint: {
            name: 'AttachmentCreationFromUri',
            customData: function (backingObject) {
                return { size: backingObject ? backingObject.size : 0 };
            },
        },
    },
    AttachmentIncludeMostRecentAttachments: {
        datapoint: { name: 'AttachmentIncludeMostRecentAttachments' },
    },
    AttachmentDoNotIncludeMostRecentAttachments: {
        datapoint: { name: 'AttachmentDoNotIncludeMostRecentAttachments' },
    },
    AttachmentShowIncludeMostRecentAttachmentsMessage: {
        datapoint: { name: 'AttachmentShowIncludeMostRecentAttachmentsMessage' },
    },
    SharingTipsConvertToClassic: { datapoint: { name: 'SharingTipsConvertToClassic' } },
};
//# sourceMappingURL=datapoints.js.map